import axios from "axios";
import { AUTH_SERVICE_URL } from '../apiConfig';

const register = (username, email, password) => {
  return axios.post(AUTH_SERVICE_URL + "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(AUTH_SERVICE_URL + "signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.username) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  return axios.post(AUTH_SERVICE_URL + "signout").then((response) => {
    return response.data;
  });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const setUser = (user) => {
  try {
    localStorage.setItem("user", JSON.stringify(user));
    return true;
  } catch (error) {
    console.error("localStorage access denied:", error);
    // Fall back to session storage or in-memory storage
    return false;
  }
};

const getUser = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("localStorage access denied:", error);
    return null;
  }
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  setUser,
  getUser,
}

export default AuthService;
